let leadMethods = {
    getModifiedIMLeadList(list=[]){
        let modified = [];

        list.forEach(imLead=>{
            modified.push({
                ...imLead,
                report_date: imLead.createdAt.slice(0,10).split("-").reverse().join("-"),
                QUERY_TIME:imLead.QUERY_TIME.slice(0,10).split("-").reverse().join("-"),
                _id:imLead._id,
            })
        })

        return modified
    }
}

export default leadMethods

